import * as Yup from "yup";
import createLocalizationsSchema from "../Localizations/createLocalizationsSchema";

const EditionSchema = (localeCodes) => Yup.object().shape({
  code: Yup
    .string()
    .label("Code")
    .required()
    .max(50),
  localizations: createLocalizationsSchema(localeCodes),
});

export default EditionSchema
